module.exports = __webpack_public_path__ + "img/png.de9f76a2.png";